import { useState, useEffect } from 'react';
import { Box, Typography, Paper, useMediaQuery } from '@mui/material';

// Define the structure for the time state
interface TimeElapsed {
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}

const CountUpTimer = () => {
	const isMobile = useMediaQuery('(max-width: 700px)');
	const startTime = new Date("2023-10-07T06:20:00").getTime();

	// This function calculates the time elapsed since the startTime
	const calculateTimeElapsed = (): TimeElapsed => {
		const now = new Date().getTime();
		const difference = now - startTime;
		let timeElapsed: TimeElapsed = {
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0
		};

		if (difference >= 0) {
			timeElapsed = {
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
				minutes: Math.floor((difference / 1000 / 60) % 60),
				seconds: Math.floor((difference / 1000) % 60),
			};
		}
		return timeElapsed;
	};

	const [timeElapsed, setTimeElapsed] = useState<TimeElapsed>(calculateTimeElapsed());

	//  wrap in useCallback to prevent infinite loop:
	// useEffect(() => {
	// 	const timer = setInterval(() => {
	// 		setTimeElapsed(calculateTimeElapsed());
	// 	}, 1000);

	// 	return () => clearInterval(timer);
	// }, [calculateTimeElapsed]);

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeElapsed(calculateTimeElapsed());
		}, 1000);

		return () => clearInterval(timer);
	}, []);

	return (
		<Box position="fixed"
			display="flex"
			sx={{ bottom: 26 }}
			flexDirection="column"
			justifyContent="center"
			p={isMobile ? 0 : 1}
			pb={isMobile ? 4 : 1}
			zIndex={-1}
			// p={0}
			width={isMobile ? '100%' : 'auto'}
		// margin="auto"
		// left="50%"
		// if transformX cannot be used, use marginLeft: '-50%'
		// marginLeft="-50%"
		// transform="translateX(-50%)"
		>
			<Paper elevation={3}
				sx={{
					p: 1,
					py: 2,
					pb: 1.5,
					backgroundColor: 'black',
					color: 'white',
					display: 'flex',
					flexDirection: 'column',
					border: '1px #333 solid',
					width: 'fit-content',
					margin: isMobile ? 'auto' : '0',
				}}>
				<Box display="flex" flexDirection="row" fontSize={12}>
					{Object.keys(timeElapsed).map((interval) => (
						<Box key={interval} sx={{ textAlign: 'center', mx: 0.8 }}>
							<Typography component="span" sx={{ display: 'block', backgroundColor: '#333', borderRadius: '5px', p: 1, width: 37 }}>
								{/* pad with 0s / 2 digits */}
								{timeElapsed[interval as keyof TimeElapsed] < 10 ? `0${timeElapsed[interval as keyof TimeElapsed]}` : timeElapsed[interval as keyof TimeElapsed]}
								{/* {timeElapsed[interval as keyof TimeElapsed]} */}
							</Typography>
							<Typography sx={{ mt: 0.5, fontSize: 11 }}>
								{interval.charAt(0).toUpperCase() + interval.slice(1)}
							</Typography>
						</Box>
					))}
				</Box>
				<Typography mt={0.8} fontSize={18}>Waiting for the Hostages</Typography>

			</Paper>
		</Box>
	);
};

export default CountUpTimer;
